import styled from 'styled-components';

import React from 'react';
import { ScaleLoader } from 'react-spinners';
const SpinnerContainer = styled.div`
	display:flex;
	align-items:center;
	justify-content:center;
`;
export const LoadingIndicator = props => {
	return (<>
		{
			props.loading &&
			<SpinnerContainer>
				<ScaleLoader width={props.width} height={props.height} loading={props.loading} />
			</SpinnerContainer>
		}
	</>);
};